<template lang="pug">
  v-menu(
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  )
    template(v-slot:activator="{ on }")
      v-text-field(
        :rules="rules"
        v-model="visibleDate"
        :label="label"
        append-icon="event"
        readonly
        outlined
        v-on="on"
      )
    v-date-picker(v-model="date" :type="type" :max="max" :min="min" locale="ru-RU" first-day-of-week="1" no-title scrollable light @change="handleChange")
</template>

<script>
import moment from 'moment'
moment.locale('ru')

export default {
  inheritAttrs: false,
  name: 'app-date-picker',
  props: {
    value: String,
    max: String,
    min: String,
    rules: [Object, Array],
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    viewFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    label: {
      type: String,
      default: 'Выберите дату'
    },
    type: {
      type: String,
      default: 'date'
    }
  },
  
  data () {
    return {
      date: null,
      menu: false,
    }
  },

  watch: {
    value (val) {
      this.date = val ? moment(val, this.format).format('YYYY-MM-DD') : null
    }
  },

  computed: {
    visibleDate () {
      return this.date ? moment(this.date, 'YYYY-MM-DD').format(this.viewFormat) 
      : this.value ? moment(this.value, this.format).format(this.viewFormat) 
      : this.rules? '': 'Не указано'
    }
  },

  methods: {
    handleChange (selectedDate) {
      this.$emit('input', moment(selectedDate, 'YYYY-MM-DD').format(this.format))
      this.menu = false
    }
  }
}
</script>


